import React from "react";
import { ArrowRight, Laptop } from "lucide-react";

// Cross-promo CTA card for the partner site DigitalNomadNicaragua.com.
// Self-hosted logo (/brand/digital-nomad-logo.png) so the preview never breaks.
// Mirrors the SjdsCrossPromo layout; placed directly under the Sister site card.
const C = {
  en: { eyebrow: "Remote work in Nicaragua", title: "Dreaming of the digital nomad life?", before: "Visit ", after: " — courses, retreats & a remote-work community.", cta: "Visit" },
  es: { eyebrow: "Trabajo remoto en Nicaragua", title: "¿Sueñas con la vida de nómada digital?", before: "Visita ", after: " — cursos, retiros y una comunidad de trabajo remoto.", cta: "Visitar" },
  fr: { eyebrow: "Travail à distance au Nicaragua", title: "Vous rêvez de la vie de nomade numérique ?", before: "Visitez ", after: " — cours, retraites et une communauté de travail à distance.", cta: "Visiter" },
  de: { eyebrow: "Remote-Arbeit in Nicaragua", title: "Träumst du vom digitalen Nomadenleben?", before: "Besuche ", after: " — Kurse, Retreats & eine Remote-Work-Community.", cta: "Besuchen" },
  zh: { eyebrow: "在尼加拉瓜远程工作", title: "向往数字游民生活吗？", before: "访问 ", after: " —— 课程、静修营与远程工作社区。", cta: "访问" },
  it: { eyebrow: "Lavoro da remoto in Nicaragua", title: "Sogni la vita da nomade digitale?", before: "Visita ", after: " — corsi, ritiri e una community di lavoro da remoto.", cta: "Visita" },
  ru: { eyebrow: "Удалённая работа в Никарагуа", title: "Мечтаете о жизни цифрового кочевника?", before: "Зайдите на ", after: " — курсы, ретриты и сообщество удалённой работы.", cta: "Открыть" },
};

export default function DigitalNomadPromo({ lang = "en" }) {
  const c = C[lang] || C.en;
  return (
    <div className="relative" data-testid="digitalnomad-promo">
      <a
        href="https://www.digitalnomadnicaragua.com"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="digitalnomad-promo-link"
        className="group flex items-center gap-4 rounded-3xl p-4 sm:p-5 border border-[color:var(--ink-2)]/10 shadow-sm hover:shadow-lg hover:-translate-y-0.5 transition-all"
        style={{ background: "linear-gradient(135deg, #0B2A4A 0%, #147C88 100%)", color: "#fff" }}
      >
        <img
          src="/brand/digital-nomad-logo.png"
          alt="Digital Nomad Nicaragua logo"
          data-testid="digitalnomad-promo-logo"
          className="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl object-cover shrink-0 shadow-md group-hover:rotate-[-3deg] transition-transform"
          style={{ background: "#FDFBF7" }}
        />
        <div className="flex-1 min-w-0">
          <p className="text-[11px] uppercase tracking-[0.18em] text-white/70 flex items-center gap-1.5">
            <Laptop className="w-3.5 h-3.5" /> {c.eyebrow}
          </p>
          <p className="text-lg sm:text-xl font-bold leading-tight" style={{ fontFamily: "Outfit" }}>
            {c.title}
          </p>
          <p className="text-sm text-white/85 mt-0.5">
            {c.before}<span className="font-semibold">DigitalNomadNicaragua.com</span>{c.after}
          </p>
        </div>
        <span className="inline-flex items-center gap-1.5 pill px-4 py-2.5 text-sm font-bold shrink-0 shadow-sm group-hover:scale-[1.03] transition-transform" style={{ background: "#F08A3C", color: "#fff" }}>
          {c.cta}
          <ArrowRight className="w-4 h-4" />
        </span>
      </a>
    </div>
  );
}
